import { zod, type FormData } from "@subly/s1/features/form/models";

export type WelcomeActions = "back" | "next";

// BRANDING
export const BrandingSchema = zod.object({
	logo: zod.object({
		light: zod.union([zod.string().min(1, "Light logo is required"), zod.file()]),
		dark: zod.union([zod.string().min(1, "Dark logo is required"), zod.file()]),
		mark: zod.union([zod.string().min(1, "Logo mark is required"), zod.file()])
	}),
	url: zod.url({ error: "Provide a valid URL" })
});
export type BrandingType = FormData<typeof BrandingSchema>;

// CMS
export const SystemSchema = zod.object({
	cms: zod.string().min(1, "A CMS is required"),
	paywall: zod.string().min(1, "A Paywall is required")
});
export type SystemType = FormData<typeof SystemSchema>;

// PRICING
export const PricingSchema = zod.object({
	articlePrice: zod.number().min(1, "The Article price is required"),
	pass: zod.object({
		enabled: zod.boolean(),
		price: zod.number(),
		duration: zod.number()
	}).superRefine((data, ctx) => {
		if (data.enabled) {
			if (data.price < 1)
				ctx.addIssue({ code: "custom", path: ["price"], message: "The Pass price is required" });
			if (data.duration < 1)
				ctx.addIssue({ code: "custom", path: ["duration"], message: "The Pass duration is required" });
		}
	})
});
export type PricingType = FormData<typeof PricingSchema>;